import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-type-selection-new-contract',
  templateUrl: './type-selection-new-contract.component.html',
  styleUrls: ['./type-selection-new-contract.component.scss']
})
export class TypeSelectionNewContractComponent implements OnInit {
  @Output() contractType: EventEmitter<number> = new EventEmitter();
  public typeDataForm: FormGroup;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.typeDataForm = this.formBuilder.group({
      type_option: [null, [Validators.required]]
    });
  }

  public onChangeTypeOption(event): void {
    this.contractType.emit(event.value);
  }

}
